import camelCase from 'lodash/camelCase';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { softwareInboxClassicRoute } from '@jira/router-routes__software-inbox-routes/src/softwareInboxClassicRoute.tsx';
import { genericProjectLayout } from '@jira/platform__layouts-generic-project-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { createLayout } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
import { InboxTableSkeleton } from '@jira/platform__skeletons/src/ui/customer-service/inbox-table/components/InboxTableSkeleton.tsx';
import { getCommonProjectResources } from '@jira/router-routes__issue-navigator-entries/src/common/getCommonProjectResources.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { inboxPageEntryPoint } from './ui/index.tsx';

export const softwareInboxClassicRouteEntry: Route = createEntry(softwareInboxClassicRoute, () => ({
	group: 'classic-software',
	apdexIgnoreParams: ['issueKey'],
	meta: {
		reporting: {
			id: 'software-inbox-classic',
			packageName: camelCase('software-inbox-classic'),
			teamName: 'boysenberry',
		},
	},
	skeleton: InboxTableSkeleton,
	navigation: {
		menuId: MenuIdProjects,
		horizontal: AsyncHorizontalNavJira,
	},
	resources: [...getCommonProjectResources()],
	layout: createLayout(genericProjectLayout),
	entryPoint: () => inboxPageEntryPoint,
	supportsPreviewPanel: true,
	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
